module.exports = __webpack_public_path__ + "static/media/product1.8648974f.jpeg";